import { render, staticRenderFns } from "./KassaAfterRedirect.vue?vue&type=template&id=38721c1e&scoped=true"
import script from "./KassaAfterRedirect.vue?vue&type=script&lang=js"
export * from "./KassaAfterRedirect.vue?vue&type=script&lang=js"
import style0 from "./KassaAfterRedirect.vue?vue&type=style&index=0&id=38721c1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38721c1e",
  null
  
)

export default component.exports